<!-- 理光实物审批 -->
<template>
	<div class="process-page">
		<!-- 机器零件信息 -->
		<div class="create-section">
			<h3>{{ partTitleObj[repairType] }}信息</h3>
			<!-- 动态生成的零件信息部分 -->
			<div class="flex part-info-box" v-for="(part, index) in partsDetailList" :key="index">
				<div class="flex-1">
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}名称</p>
							<p class="content">{{ part.partsName }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
					</div>
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}编号</p>
							<p class="content">{{ part.partsNumber }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
					</div>
					<div class="part-info-item" v-if="part.partsNumberNew != null">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}新编号</p>
							<p class="content">{{ part.partsNumberNew }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsNumberNew)"></i>
					</div>
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">申请数量</p>
							<p class="content">{{ part.partsAmount }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
					</div>
					<div class="part-info-item" v-if="part.partsBatchNumber != null">
						<div class="info-box">
							<p class="title">批号</p>
							<p class="content">{{ part.partsBatchNumber }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsBatchNumber)"></i>
					</div>
					<img class="watermark" v-if="part.lastResult == 1" src="@/assets/images/claim-fail.png" alt="" />
					<img class="watermark" v-if="part.currentAudit && part.currentAudit.auditStatus == 3" src="@/assets/images/claim-success.png" alt="" />
				</div>
				<div class="flex-1 part-info-box-right">
					<div class="right-item">实物检测结果： {{ part.partsResult == 1 ? "拒绝" : "同意" }}</div>
					<div class="right-item" v-if="part.partsTest">测试结果： {{ part.partsTest == 1 ? "正常" : "故障" }}</div>
					<div class="right-item">零件索赔进度：{{ progressMsg(part) }}</div>
					<div v-if="part.currentAudit && part.currentAudit.auditStatus == 3" class="right-item">
						发货订单号：{{ part.partsClaimExpress.expressNumber }}
					</div>
					<div v-if="part.currentAudit && part.currentAudit.auditStatus == 3" class="right-item">
						发货操作时间(系统)：{{ part.currentAudit.operTime }}
					</div>
					<div v-if="part.currentAudit && part.currentAudit.auditStatus == 3" class="right-item">发货时间(录入)：{{ part.actualShippingTime }}</div>
					<div class="right-item word-bread-all" v-if="part.currentAudit && [2, 3, -2].includes(part.currentAudit.auditStatus)">
						发货批注： {{ part.currentAudit.remark }}
					</div>
					<!-- <div class="right-item" v-if="partsClaimExpress != null">
						<el-button type="info" @click="handleCheckExpress(null)">查看索赔邮寄信息</el-button>
					</div> -->
					<div class="right-item" v-if="part.partsTestReturnFlag == '1' && part.fileList.length > 0">
						<span>附件说明</span>
						<div class="flex-1">
							<FileList :file-list="part.fileList" class="mt4"></FileList>
						</div>
					</div>
					<div class="right-item" v-if="part.partsClaimExpressTestReturn != null">
						<el-button type="info" size="small" @click="handleCheckExpress(part.partsClaimExpressTestReturn)">查看测试回寄信息</el-button>
					</div>
					<div class="right-item" v-if="part.partsTestReturnFlag == null">
						{{ part.partsTestNext == "1" ? "此测试件需退回代理商" : "此测试件需寄往仓库" }}
					</div>
					<div class="right-item" v-if="part.partsTestReturnFlag == '1'">审批批注：{{ part.testReturnAudit.remark }}</div>
					<div class="right-item" v-if="part.partsTestReturnFlag == null">
						审批批注
						<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="part.auditRemarks"></el-input>
					</div>
					<div class="right-item" v-if="part.partsTestReturnFlag == null">
						<el-button type="primary" @click="handleAddressInfo(part)">填写测试回寄信息</el-button>
					</div>
					<div class="right-item" v-if="part.partsTestReturnFlag == null">
						<el-button type="primary" size="small" @click="handleSubmit(part)">提交</el-button>
					</div>
				</div>
			</div>
		</div>
		<AddressInfo ref="addressInfo" @refresh="setFaultyExpress"></AddressInfo>
		<ShowAddressInfo ref="showAddressInfo"></ShowAddressInfo>
		<!-- 流程信息 -->
		<CommonCollapse2 />
	</div>
</template>
<script>
import { claimOrdersInfo, testReturn } from "@/api/claim";
import AddressInfo from "../components/addressInfo.vue";
import ShowAddressInfo from "../components/showAddressInfo.vue";
import FileList from "../components/FileList.vue";
import CommonCollapse2 from "../components/CommonCollapse2.vue";
import { debounce } from "@/utils/debounce";
export default {
	components: {
		FileList,
		AddressInfo,
		ShowAddressInfo,
		CommonCollapse2,
	},
	data() {
		return {
			repairType: "",
			partsDetailList: [],
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
			innerAdvanceCode: "",
			applyAdvanceCode: "",
			partsClaimExpress: null,
		};
	},
	mounted() {
		// 获取单个索赔信息
		this.getInfo();
	},
	methods: {
		getInfo() {
			const claimId = sessionStorage.getItem("claimId");
			this.getClaimOrdersInfo(claimId);
		},
		getClaimOrdersInfo(claimId) {
			let self = this;
			claimOrdersInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						self.innerAdvanceCode = r.data.partsClaimOrders.innerAdvanceCode;
						self.applyAdvanceCode = r.data.partsClaimOrders.applyAdvanceCode;
						self.repairType = r.data.repairType;
						// partsDetailList
						self.partsDetailList = r.data.partsDetailList;
						self.getExpress({
							id: r.data.partsClaimOrders.id,
							linkTable: "parts_claim_orders",
							expressType: "1",
						});
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		// 提交
		handleSubmit: debounce(function (part) {
			if (part.partsClaimExpressTestReturn == null) {
				this.$message.error(`请填写测试回寄信息`);
				return;
			}
			if (["", null, undefined].includes(part.auditRemarks)) {
				this.$message.error(`请填写审批批注`);
				return;
			}
			const params = {
				id: part.id,
				auditRemarks: part.auditRemarks,
			};
			testReturn(params, true)
				.then((r) => {
					if (r.code == "0") {
						this.$message({
							message: "操作成功",
							type: "success",
						});
						this.getInfo();
					} else {
						this.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		}, 1000),
		// 地址信息
		handleAddressInfo(part) {
			this.$refs.addressInfo.init({
				id: part.id,
				linkTable: "parts_claim_detail",
				expressType: "5",
				applyAdvanceCode: this.applyAdvanceCode,
				innerAdvanceCode: this.innerAdvanceCode,
				advanceTypeFlag: part.partsTestNext == 2 ? "1" : "2",
			});
		},
		// 设置faultyExpress
		setFaultyExpress(id, partsClaimExpress) {
			for (const element of this.partsDetailList) {
				if (element.id == id) {
					element.partsClaimExpressTestReturn = partsClaimExpress;
				}
			}
		},
		// 根据id获取寄件和收件邮寄地址
		getExpress(params) {
			let self = this;
			self.$request.post("getExpress", false, params, function (r) {
				if (r.code == "0") {
					if (r.data == null) {
						self.partsClaimExpress = null;
					} else {
						self.partsClaimExpress = r.data;
					}
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 点击查看实物寄件信息
		handleCheckExpress(partsClaimExpress) {
			const express = partsClaimExpress ? partsClaimExpress : this.partsClaimExpress;
			this.$refs.showAddressInfo.init(express);
		},
		// 索赔进度
		progressMsg(part) {
			let msg = "";
			if (part.partsResult == 1) {
				msg = "实物审批被拒";
			} else if (part.currentAudit) {
				if (part.currentAudit.auditStatus == 1) {
					msg = "实物审批已通过";
				} else if (part.currentAudit.auditStatus == 2) {
					msg = "无货等待";
				} else if (part.currentAudit.auditStatus == 3) {
					msg = "索赔成功";
				} else if (part.currentAudit.auditStatus == -2) {
					msg = "拒绝发货";
				} else {
					msg = "实物审批已通过";
				}
			} else {
				return "";
			}
			return msg;
		},
	},
};
</script>
<style lang="scss" scoped>
.process-page ::v-deep .el-collapse-item__header {
	height: 60px;
	line-height: unset;
}
.title-content {
	width: 100%;
}
.title-box {
	display: flex;
	&:first-child {
		margin-bottom: 10px;
		span {
			font-size: 1rem;
			font-weight: 400;
			line-height: 1.5;
			letter-spacing: 0.00938em;
		}
	}
	span {
		flex: 1;
		&:last-child {
			text-align: right;
			margin-right: 20px;
		}
	}
}
.create-section {
	border-top: 1px solid #ddd;
	padding-top: 20px;
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
	min-width: 0;
	word-wrap: break-word;
}
h3 {
	margin-left: 10px;
}
.part-info-box {
	margin: 10px 5px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.delete-btn-box {
		text-align: right;
		font-size: 20px;
		cursor: pointer;
		padding-right: 5px;
	}
	.flex-1 {
		position: relative;
		min-width: 0;
		word-wrap: break-word;
		.watermark {
			width: 100px;
			position: absolute;
			top: 0;
			right: 0;
		}
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	.info-box {
		flex: 1;
		.title {
			margin-top: 10px;
		}
		.content {
			border: 1px solid #ddd;
			border-radius: 5px;
			padding: 9px 12px;
			margin-top: 5px;
			font-size: 13px;
		}
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
	font-size: 16px;
	.right-item {
		margin-bottom: 10px;
	}
}
.create-footer {
	text-align: right;
	margin-top: 20px;
	padding: 20px;
	border-top: 1px solid #ddd;
}
.process-item {
	margin-top: 10px;
	p {
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.75;
		letter-spacing: 0.00938em;
		margin-bottom: 10px;
	}
	.el-select {
		width: 100%;
	}
}
.t-r {
	text-align: right;
}
.mt10 {
	margin-top: 10px;
}
.mb20 {
	margin-bottom: 20px;
}
.report-book-box {
	margin-top: 20px;
	h2 {
		margin-bottom: 10px;
	}
	.title1 {
		font-size: 14px;
		margin-top: 10px;
	}
	.title2 {
		color: #909399;
		margin-top: 5px;
		margin-bottom: 10px;
	}
}
.tips {
	font-size: 13px;
	color: #909399;
}
.word-bread-all {
	white-space: pre-line;
	word-break: break-all;
}
</style>
